// async loader of maps
export const asyncLoad = (url) => {
  if (Array.isArray(url)) {
    const self = this;
    const promisesArray = [];
    url.forEach((item) => {
      if (self) {
        promisesArray.push(self.script(item));
      }
    });
    return Promise.all(promisesArray);
  }

  return new Promise((resolve, reject) => {
    let alreadyResolved = false;
    const insertAnchor = document.getElementsByTagName('script')[0];
    const loadedScript = document.createElement('script');

    loadedScript.type = 'text/javascript';
    loadedScript.src = url;
    loadedScript.async = true;
    loadedScript.onreadystatechange = () => {
      if (!alreadyResolved) {
        alreadyResolved = true;
        resolve(this);
      }
    };
    loadedScript.onload = loadedScript.onreadystatechange;
    loadedScript.onabort = reject;
    loadedScript.onerror = loadedScript.onabort;
    insertAnchor.parentNode.insertBefore(loadedScript, insertAnchor);
  });
};

// simple check for already downloaded maps
export const alreadyLoaded = () => !!window.ymaps;

// just in case if we will have another place for ymaps instance
export const getYMapsInstance = () => {
  const { ymaps } = window;
  return ymaps;
};

// filter used in clusterer icon layout, in order to have different scale from point count used in inline svg
// {{properties.geoObjects.length|scale: "size"}} <- that way
// where
// properties.geoObjects.length - property in filter-function
// scale - filter-function name
// ' "size"' - filter-function option, its parsing all symbols before }
// its return values then can be used in every part of inline svg/html templates
export const scale = (data, property, commandRaw) => {
  if (!commandRaw || commandRaw.length === 0) {
    return property;
  }
  // === translate command from ' "some_command"' to 'some_command'
  const quotes = /"/gi;
  const commandNoQuotes = commandRaw.replace(quotes, '');
  const command = commandNoQuotes.replace(' ', '');
  // ===
  let baseValue;
  const propertyOrder = property.toString().length;
  switch (propertyOrder) {
    case 1:
      baseValue = 38;
      break;
    case 2:
      baseValue = 48;
      break;
    case 3:
      baseValue = 54;
      break;
    default:
      baseValue = 38;
  }
  // ===
  if (command === 'size') {
    // base 38px
    return baseValue;
  } else if (command === 'center' || command === 'bigRadius') {
    // base 19px
    return baseValue / 2;
  } else if (command === 'smallRadius') {
    // base 25px
    return baseValue / 2 - 7;
  } else if (command === 'textCenter') {
    // base 25px
    return baseValue / 2 + 6;
  }
  return baseValue;
};
